import Vue from 'vue'
import { MLInstaller, MLCreate } from 'vue-multilanguage'
import { english } from './languages/english'
import { italian } from './languages/italian'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'italian',
  save: process.env.NODE_ENV === 'production',
  languages: [
    english,
    italian
  ]
})



// WEBPACK FOOTER //
// ./src/ml.js